export default "__VITE_ASSET__81beda64__"